import { withNumberOfDecimals as countWithNumberOfDecimals } from "../../../core/helpers/count-formatting-util.js";
import { withNumberOfDecimals as currencyWithNumberOfDecimals } from "../../../core/helpers/currency-formatting-util.js";
import { object } from "klassified";
import percentage from "../../../core/percentage.js";
import ratio from "../../../core/ratio.js";

/**
 * `keyFigureValueFormatter` is a simple service used to retrieve the
 * correct formatter depending on the keyFigure value type.
 */

const keyFigureValueFormatter = object.subclass((that) => {
	that.formatterFor = function (keyFigureValue) {
		if (!keyFigureValue) {
			return function (each) {
				return each;
			};
		}

		let formatter;

		switch (keyFigureValue.getValueType()) {
			case "Percent": {
				formatter = percentage;
				break;
			}
			case "Ratio": {
				formatter = ratio;
				break;
			}
			case "Count": {
				formatter = {
					withNumberOfDecimals: countWithNumberOfDecimals,
				};

				break;
			}
			case "Amount": {
				formatter = {
					withNumberOfDecimals: currencyWithNumberOfDecimals,
				};

				break;
			}
			case "Raw": {
				formatter = { withNumberOfDecimals: () => (string) => string };
				break;
			}
			default: {
				throw `Unknown KPI type: "${keyFigureValue.getValueType()}"`;
			}
		}

		return formatter.withNumberOfDecimals(
			keyFigureValue.getNumberOfDecimals(),
		);
	};

	that.format = function (keyFigureValue) {
		return that.formatterFor(keyFigureValue)(keyFigureValue.getValue());
	};
});

const defaultFormatter = keyFigureValueFormatter();
keyFigureValueFormatter.format = defaultFormatter.format;
keyFigureValueFormatter.formatterFor = defaultFormatter.formatterFor;

export default keyFigureValueFormatter;
